import { PayrollPeriod as LegacyPayrollPeriod } from '../../../models'
import { transformToPeriod } from '../Period/PeriodTransformers'
import { PayrollPeriod } from './PayrollPeriod'

export const transformLegacyPayrollPeriodToPayrollPeriod = (legacy: LegacyPayrollPeriod): PayrollPeriod => ({
    id: legacy.id,
    year: legacy.year,
    periodNumber: legacy.periodNumber,
    canEdit: legacy.canEdit,
    period: transformToPeriod(legacy.start, legacy.end.date),
})
